/**
 * Session 31 · Zentrale Event-Namen für Tracking.
 * Wird von dispatcher.js verwendet, Mapping zu Meta- und GA4-Namen dort.
 */
export const EVENTS = Object.freeze({
  PAGE_VIEW: "page_view",
  VIEW_CONTENT: "view_content",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  ADD_PAYMENT_INFO: "add_payment_info",
  PURCHASE: "purchase",
  LEAD: "lead",
});
